module.exports = __webpack_public_path__ + "static/media/shower1.40792608.gif";